import axios from 'axios';
import { containerTypes } from '../const';

class OcrService {
  getContainer = (file: any) => {
    const formData = new FormData();
    formData.append('image', file);

    return axios
      .post('/ocr', formData, {
        params: { notLoading: true },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        baseURL: process.env.REACT_APP_TEZPORT_API_URL,
      })
      .then((res) => {
        if (!containerTypes.some((type) => type.value === res.data.type)) res.data.type = '';
        return res;
      });
  };
}

export const ocrService = new OcrService();
